import { Link } from "react-router-dom";
import { Linkedin, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-800 bg-slate-950" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-display font-semibold text-2xl text-white">
            Samanvay<span className="text-brand"> HR</span>
          </p>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
            A staffing and HR services studio for companies that refuse to hire average.
            Permanent hiring, contract staffing, and leadership search — done with craft.
          </p>
          <div className="mt-6 flex items-center gap-4">
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" data-testid="footer-social-linkedin" className="text-slate-500 hover:text-brand transition-colors duration-200">
              <Linkedin size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" data-testid="footer-social-twitter" className="text-slate-500 hover:text-brand transition-colors duration-200">
              <Twitter size={18} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-social-instagram" className="text-slate-500 hover:text-brand transition-colors duration-200">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" data-testid="footer-link-about" className="text-slate-400 hover:text-white transition-colors duration-200">About</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="text-slate-400 hover:text-white transition-colors duration-200">Services</Link></li>
            <li><Link to="/industries" data-testid="footer-link-industries" className="text-slate-400 hover:text-white transition-colors duration-200">Industries</Link></li>
            <li><Link to="/careers" data-testid="footer-link-careers" className="text-slate-400 hover:text-white transition-colors duration-200">Careers</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">For You</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/careers" data-testid="footer-link-find-job" className="text-slate-400 hover:text-white transition-colors duration-200">Find a job</Link></li>
            <li><Link to="/contact" data-testid="footer-link-hire" className="text-slate-400 hover:text-white transition-colors duration-200">Hire talent</Link></li>
            <li><Link to="/register" data-testid="footer-link-employer" className="text-slate-400 hover:text-white transition-colors duration-200">Employer portal</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-slate-400 hover:text-white transition-colors duration-200">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">Reach Us</p>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-3"><Mail size={15} className="text-brand" /> info@samanvayhr.com</li>
            <li className="flex items-center gap-3"><Phone size={15} className="text-brand" /> +91 91122 33574</li>
            <li className="flex items-start gap-3"><MapPin size={15} className="text-brand mt-0.5 shrink-0" /> Arenesha, 6th Floor, The District, Near Medicover Hospital, Financial District, Nanakramguda, Hyderabad, Telangana 500032</li>
          </ul>
        </div>
      </div>

      <div className="overflow-hidden border-t border-slate-800/60">
        <p className="font-display font-bold text-[13vw] leading-none text-center text-white/[0.05] select-none whitespace-nowrap -mb-[3vw]">
          SAMANVAY
        </p>
      </div>

      <div className="border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© 2026 Samanvay HR Services. All rights reserved.</p>
          <p className="text-xs text-slate-600">Aligned with care in Hyderabad.</p>
        </div>
      </div>
    </footer>
  );
};
